/* eslint-disable */
import { base, baseUpload, baseXlsx } from '@/utils/api'

const ENDPOINT = '/emergency-room'

export default {
  getDashboardData() {
    return base.get(`${ENDPOINT}/dashboard`)
  },
  getEmergencyRoomItems(page, query, status, priority) {
    const config = {
      params: { page, query, status, priority }
    }
    return base.get(`${ENDPOINT}/items`, config)
  },
  getFirstEmergencyRoomItem() {
    return base.get(`${ENDPOINT}/first-item`)
  },
  startAttendance(emergencyRoomItemId, attendanceId) {
    return base.post(`${ENDPOINT}/start-attendance`, {
      emergencyRoomItemId,
      attendanceId
    })
  },
  getEmergencyRoomItemByPatientId(patientId) {
    return base.get(`${ENDPOINT}/patient/${patientId}`)
  },
  patientMissed(emergencyRoomItemId) {
    return base.patch(`${ENDPOINT}/missed/${emergencyRoomItemId}`)
  }
}
